export default __webpack_public_path__ + "static/media/lunchFasting.cc8ce3fd.svg";